function initialState () {
  return {
    selectedUrgencyId: '',
    notes: '',
    uploadedImages: [],
  };
}

export default {
  namespaced: true,
  state: initialState,
  getters: {
    selectedUrgencyId (state) {
      return state.selectedUrgencyId;
    },
    notes (state) {
      return state.notes;
    },
    uploadedImages (state) {
      return state.uploadedImages;
    },
    isValid (state) {
      return !!state.selectedUrgencyId;
    },
  },
  actions: {
    setSelectedUrgencyId ({ commit }, selectedUrgencyId) {
      commit('setSelectedUrgencyId', selectedUrgencyId);
    },
    setNotes ({ commit }, notes) {
      commit('setNotes', notes);
    },
    setUploadedImages ({ commit }, images) {
      commit('setUploadedImages', images);
    },
    clear ({ commit }) {
      commit('clear');
    },
  },
  mutations: {
    setSelectedUrgencyId (state, selectedUrgencyId) {
      state.selectedUrgencyId = selectedUrgencyId;
    },
    setNotes (state, notes) {
      state.notes = notes;
    },
    setUploadedImages (state, images) {
      state.uploadedImages = images;
    },
    clear (state) {
      Object.assign(state, initialState());
    },
  },
};
